import * as z from "zod"

export const DBBrandClassModel = z.object({
  id: z.number().int(),
  slug: z.string(),
  intlKey: z.string().nullish(),
  name: z.string(),
})
